var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (item) {var hasSubSite = function(item) { return item.subsite ? 'with-src' : ''; }

pug_html = pug_html + "\u003Cdiv class=\"list__item\"\u003E\u003Ca" + (" class=\"list__pic-wrapper vgtrk-lazy-preloader\""+pug.attr("href", item.url, true, true)) + "\u003E";
if ((item.picture && item.picture.url)) {
pug_html = pug_html + "\u003Cimg" + (" class=\"list__pic vgtrk-lazy\""+pug.attr("alt", item.picture.alt, true, true)+pug.attr("data-src", item.picture.url, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"no-photo\"\u003E\u003Cimg class=\"list__pic\" src=\"\u002Fi\u002Ffake_lw.png\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003Cdiv class=\"list__info\"\u003E\u003Cdiv class=\"list__data\"\u003E\u003Cdiv class=\"list__date\"\u003E" + (null == (pug_interp = item.datePub.day) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"list__time\"\u003E" + (null == (pug_interp = item.datePub.time) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
if ((item.subsite && item.subsite.title !== null && item.subsite.url !== null)) {
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle\"\u003E";
if ((item.subsite && item.subsite.url)) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", item.subsite.url, true, true)+" target=\"_blank\"") + "\u003E\u003Cspan class=\"list__src\"\u003E" + (null == (pug_interp = item.subsite.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"list__src\"\u003E" + (null == (pug_interp = item.subsite.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if ((item.routesToPages !== null)) {
// iterate item.routesToPages
;(function(){
  var $$obj = item.routesToPages;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var rout = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle\"\u003E\u003Ca" + (" class=\"list__src\""+pug.attr("href", rout.routePath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = rout.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var rout = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle\"\u003E\u003Ca" + (" class=\"list__src\""+pug.attr("href", rout.routePath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = rout.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
if ((item.topic !== null)) {
pug_html = pug_html + "\u003Cdiv class=\"list__subtitle theme\"\u003E\u003Ca" + (" class=\"list__src\""+pug.attr("href", item.topic.href, true, true)) + "\u003E" + (null == (pug_interp = item.topic.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if ((item.hasVideos)) {
pug_html = pug_html + "\u003Ch3 class=\"list__title has_video\"\u003E\u003Ca" + (pug.attr("href", item.url, true, true)) + "\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fh3\u003E";
}
else {
pug_html = pug_html + "\u003Ch3 class=\"list__title\"\u003E\u003Ca" + (pug.attr("href", item.url, true, true)) + "\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fh3\u003E";
}
if ((item.hasVideos)) {
pug_html = pug_html + "\u003Cdiv class=\"list__icon\"\u003E\u003Ca" + (" class=\"list__icon-play\""+pug.attr("href", item.url, true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined));;return pug_html;};
module.exports = template;